import { createFileRoute } from '@tanstack/react-router'
import * as v from 'valibot'
import { useLingui } from '@lingui/react/macro'
import { useAppForm } from '@/lib/use-app-form'
import { PasswordAuthLayout } from './-components/shared/password-auth-layout'
import { AuthPending } from './-components/app-layout-skeleton'
import { useMutation } from '@tanstack/react-query'
import { toast } from '@/lib/toast'
import { trpc } from '@/main'

export const Route = createFileRoute('/_app/_public/begin-password-reset')({
  component: RouteComponent,
  pendingComponent: AuthPending,
})

function RouteComponent() {
  const { t } = useLingui()
  const { mutateAsync: beginPasswordReset } = useMutation(trpc.auth.beginPasswordReset.mutationOptions())

  const form = useAppForm({
    validators: { onChange: v.object({ email: v.pipe(v.string(), v.email()) }) },
    defaultValues: { email: '' },
    onSubmit: async ({ value }) => {
      await beginPasswordReset(value.email)
      const email = value.email
      toast.success(
        t`If this account exists, you will receive an email to ${email} with the steps to follow to reset your password.`,
      )
    },
  })

  return (
    <PasswordAuthLayout
      title={t`Reset password`}
      subtitle={t`Enter the email address associated with your account and we will send you a link to reset your password.`}
    >
      <form
        onSubmit={(event) => {
          event.preventDefault()
          form.handleSubmit()
        }}
        className="flex flex-col gap-3"
      >
        <form.AppField name="email" children={(field) => <field.TextField label={t`Email`} type="email" />} />
        <form.AppForm>
          <form.SubmitButton label={t`Send`} />
        </form.AppForm>
      </form>
    </PasswordAuthLayout>
  )
}
